import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4 text-xl font-bold" }, "Penjualan Snack", -1)
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 gap-3" }
const _hoisted_3 = { class: "border-grey-3 rounded-xl p-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-semibold" }, "Snack Terjual", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "w-full table-variant text-neutral500 px-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left w-3/5 text-grey" }, "Snack"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left w-1/5 text-grey" }, "Jumlah Terjual"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-right w-1/5 text-grey" }, "Nominal")
  ])
], -1)
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = { class: "text-sm text-left w-3/5" }
const _hoisted_10 = { class: "flex items-center gap-2" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "text-sm text-left w-1/5" }
const _hoisted_13 = { class: "text-sm text-right w-1/5" }
const _hoisted_14 = {
  key: 0,
  class: "flex py-3 border-top-2px-black"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "w-3/5 text-sm font-extrabold" }, "Total Snack Terjual", -1)
const _hoisted_16 = { class: "w-1/5 text-sm font-extrabold" }
const _hoisted_17 = { class: "w-1/5 text-sm font-extrabold text-right" }
const _hoisted_18 = {
  key: 1,
  class: "text-sm text-center pt-4"
}
const _hoisted_19 = { class: "border-grey-3 rounded-xl p-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-semibold" }, "Sisa Snack Di Kondektur", -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "w-full table-variant text-neutral500 px-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left w-4/5 text-grey" }, "Snack"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left w-1/5 text-grey" }, "Jumlah Sisa")
  ])
], -1)
const _hoisted_24 = { class: "text-sm" }
const _hoisted_25 = { class: "text-sm text-left w-4/5" }
const _hoisted_26 = { class: "flex items-center gap-2" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "text-sm text-left w-1/5" }
const _hoisted_29 = {
  key: 0,
  class: "flex py-3 border-top-2px-black"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "w-4/5 text-sm font-extrabold" }, "Total Snack Sisa", -1)
const _hoisted_31 = { class: "w-1/5 text-sm font-extrabold" }
const _hoisted_32 = {
  key: 1,
  class: "text-sm text-center pt-4"
}

import numberFormat from '@/utils/helpers/numberFormat'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import { onMounted, ref, computed } from 'vue'
import defaulListImage from '@/assets/img/icon/cross-black-background-grey.svg'
import { useStore } from 'vuex'
import apiUseCase from '@/usecase/apiUseCase'
import environment from '@/configs/environtment'
import changeImagePathPrefix from '@/utils/helpers/changeImagePathPrefix'


export default /*#__PURE__*/_defineComponent({
  __name: 'SnackSummary',
  props: {
  dataHeader: {
    default: null as any,
  }
},
  setup(__props) {

const props = __props


const datadummy = [
  {
    Id: 0,
    SnackId: 0,
    SnackName: 'Snack A',
    SnackImage: null,
    SnackPrice: 1000,
    AllocatedQuantity: 10,
    SoldQuantity: 8,
    ReturnedQuantity: 2
  },
  {
    Id: 1,
    SnackId: 1,
    SnackName: 'Snack B',
    SnackImage: null,
    SnackPrice: 1500,
    AllocatedQuantity: 10,
    SoldQuantity: 10,
    ReturnedQuantity: 0
  },
  {
    Id: 2,
    SnackId: 2,
    SnackName: 'Snack C',
    SnackImage: null,
    SnackPrice: 1500,
    AllocatedQuantity: 10,
    SoldQuantity: 3,
    ReturnedQuantity: 7
  }
]
const endpoint = '/transaction/v2/TransactionPps'
const store = useStore()
const soldSnackList = ref([]) as any
const remainSnackList = ref([]) as any
const TotalSoldQuantity = ref(0)
const GrandTotalIncome = ref(0)
const TotalReturnedQuantity = ref(0)
const dataHeader = computed(() => props.dataHeader)
const dataSnack = ref()

const countGrandTotal = (data: any) => {
  // console.log('data', data)
  const result = data.reduce(
    (acc: any, item: any) => {
      acc.totalPrice += item.Price * item.SoldQuantity
      return acc
    },
    { totalPrice: 0 }
  )
  GrandTotalIncome.value = result.totalPrice
}

const totalSnack = (data: any) => data.reduce((sum: any, item: any) => sum + (item.SoldQuantity ?? item.ReturnedQuantity), 0)

const setSnackList = async (dataSource: any) => {
  // eslint-disable-next-line array-callback-return
  dataSource.TransactionPpSnackStocks.map(async (data: any) => {
    const objDeafault = {
      Id: data.Id,
      // Image: data.SnackImage,
      Image: data.SnackImage ? `${environment.getApiImageBaseUrl()}${changeImagePathPrefix(data.SnackImage)}` : null,
      Name: data.SnackName,
      Price: data.SnackPrice,
      AllocatedQuantity: data.AllocatedQuantity,
      NetIncome: data.NetSoldAmount
    }

    if (data.SoldQuantity > 0) {
      const obj = {
        ...objDeafault,
        SoldQuantity: data.SoldQuantity,
        TotalIncome: data.SoldQuantity * data.SnackPrice
      }
      soldSnackList.value.push(obj)
    }
    if (data.CurrentStock > 0) {
      const obj = {
        ...objDeafault,
        ReturnedQuantity: data.CurrentStock
      }
      remainSnackList.value.push(obj)
    }
  })
  // console.log('cek', [soldSnackList.value, remainSnackList.value])
  await countGrandTotal(soldSnackList.value)
  TotalSoldQuantity.value = await totalSnack(soldSnackList.value)
  TotalReturnedQuantity.value = await totalSnack(remainSnackList.value)
}

const getAllData = async () => {
  store.dispatch('showLoading')
  try {
    await apiUseCase.get(`${endpoint}/Snack/Summary/ByTransactionPp/${dataHeader.value.Id}`).then((response) => {
      const { error, result } = response
      if (!error) {
        dataSnack.value = result
        setSnackList(result)
      }
    })
  } catch (error) {
    console.log('error', error)
  }
  store.dispatch('hideLoading')
}

onMounted(() => {
  // console.log('start')
  getAllData()
  // setSnackList(datadummy)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_unref(soldSnackList).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("table", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("tbody", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(soldSnackList), (data) => {
                    return (_openBlock(), _createElementBlock("tr", { key: data }, [
                      _createElementVNode("td", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("img", {
                            src: data.Image ?? _unref(defaulListImage),
                            class: "rounded-lg",
                            style: _normalizeStyle(data.Image ? 'width: 50px;' : 'width: 40px;'),
                            alt: "SnackThumbnail"
                          }, null, 12, _hoisted_11),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", null, _toDisplayString(data.Name), 1),
                            _createElementVNode("div", null, _toDisplayString(`${_unref(rupiahFormat)(data.Price)} / pack`), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_12, _toDisplayString(`${_unref(numberFormat)(data.SoldQuantity)} Pack`), 1),
                      _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(rupiahFormat)(data.NetIncome)), 1)
                    ]))
                  }), 128))
                ])
              ]),
              (_unref(soldSnackList).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, _toDisplayString(`${_unref(numberFormat)(TotalSoldQuantity.value)} Pack`), 1),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(`${_unref(rupiahFormat)(dataSnack.value.TotalNetSoldAmount)}`), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, "Tidak Ada Data"))
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        (_unref(remainSnackList).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("table", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("tbody", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(remainSnackList), (data) => {
                    return (_openBlock(), _createElementBlock("tr", { key: data }, [
                      _createElementVNode("td", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("img", {
                            src: data.Image ?? _unref(defaulListImage),
                            class: "rounded-lg",
                            style: _normalizeStyle(data.Image ? 'width: 50px;' : 'width: 40px;'),
                            alt: "SnackThumbnail"
                          }, null, 12, _hoisted_27),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", null, _toDisplayString(data.Name), 1),
                            _createElementVNode("div", null, _toDisplayString(`${_unref(rupiahFormat)(data.Price)} / pack`), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(`${_unref(numberFormat)(data.ReturnedQuantity)} Pack`), 1)
                    ]))
                  }), 128))
                ])
              ]),
              (_unref(remainSnackList).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, _toDisplayString(`${_unref(numberFormat)(TotalReturnedQuantity.value)} Pack`), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_32, "Tidak Ada Data"))
      ])
    ])
  ]))
}
}

})